// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-right.double"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13.5 16.5L18 12L13.5 7.5M7 16.5L11.5 12L7 7.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronRightDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-right-double',
    ref,
    icon: element,
  },
));

ChevronRightDoubleIcon.displayName = 'ChevronRightDoubleIcon';

export default ChevronRightDoubleIcon;
